import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

interface CustomSchedulationTypeItemVM extends ItemVM {
  textValue: string;
}
const list: Readonly<Array<CustomSchedulationTypeItemVM>> = Object.freeze([
  {
    id: 1,
    value: 'TIME',
    textValue: 'Periodica',
  },
  {
    id: 2,
    value: 'EVENT',
    textValue: 'Al termine di un altro job',
  },
  {
    id: 3,
    value: 'null',
    textValue: 'A richiesta',
  },
]);

interface SchedulationTypeListProps {
  value: string;
  disabled?: boolean;
  error?: boolean;
  onChange: (type: SelectChangeEvent<string>) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

const SchedulationTypeListComponent = ({
  value,
  disabled,
  onChange,
  required,
  error,
  label = 'Tipo schedulazione',
  id = 'schedulationType',
}: SchedulationTypeListProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={idTag}>{required ? `${label} *` : label}</InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        error={error}
        label={required ? `${label} *` : label}
        disabled={disabled}
        value={value}
        onChange={onChange}
      >
        {list.map((status: CustomSchedulationTypeItemVM) => (
          <MenuItem key={status.id} value={status.value}>
            {status.textValue}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SchedulationTypeListComponent.displayName = 'Schedulation type list Select';

export const SchedulationTypeList = memo(
  SchedulationTypeListComponent
) as typeof SchedulationTypeListComponent;

export default SchedulationTypeList;
